import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const TestCompletedFilterSlice = createSlice({
  name: "TestCompletedFilter",
  initialState: {} as IReduxState<any>,
  reducers: {
    TestCompletedFilter: (state,_: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successTestCompletedFilter: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureTestCompletedFilter: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearTestCompletedFilter: (state) => {
      state.data = {};
    },
  },
});

export const {
  failureTestCompletedFilter,
  successTestCompletedFilter,
  clearTestCompletedFilter,
  TestCompletedFilter,
} = TestCompletedFilterSlice.actions;

export default TestCompletedFilterSlice.reducer;
